import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').component('countrySelect', {
        bindings: {
            model: '=',
            onChange: '&',
            disabled: '<',
            required: '<'
        },
        controller: CountrySelect,
        templateUrl: require('./country-select.html')
    });

    CountrySelect.$inject = ['CountrySvc'];

    function CountrySelect(CountrySvc) {
        var ctrl = this;

        /**
         * Initialisation du composant.
         */
        ctrl.$onInit = function() {
            loadCountries();
        };

        /**
         * Getter/Setter permettant d'accéder à la valeur du pays sélectionner.
         * Cette fonction permet de notifier des changement de valeur.
         */
        ctrl.country = function(value) {
            if (arguments.length) {
                // Setter
                ctrl.model = value;
                if (ctrl.onChange) {
                    ctrl.onChange({ country: ctrl.model });
                }
            } else {
                // Getter
                return ctrl.model;
            }
        };

        /**
         * Chargement de la liste des pays.
         */
        function loadCountries() {
            return CountrySvc.getAll().then(function(data) {
                ctrl.countries = data;
                return data;
            });
        }
    }
})();
